import { IAPIPaymentBreakDownModel } from "../interfaces";

export class PaymentBreakDownModel {
  oneTimeCount: number;
  recurringCount: number;
  totalCount: number;
  oneTimePercentage: number;
  recurringPercentage: number;

  constructor(data?: Partial<PaymentBreakDownModel>) {
    this.oneTimeCount = data?.oneTimeCount || 0;
    this.recurringCount = data?.recurringCount || 0;
    this.totalCount = data?.totalCount || 0;
    this.oneTimePercentage = data?.oneTimePercentage || 0;
    this.recurringPercentage = data?.recurringPercentage || 0;
  }

  static deserializeAPIModel(
    data: IAPIPaymentBreakDownModel,
  ): PaymentBreakDownModel {
    const mappedData: Partial<PaymentBreakDownModel> = {
      oneTimeCount: data.oneTimeCount,
      recurringCount: data.recurringCount,
      totalCount: data.totalCount,
      oneTimePercentage: data.oneTimePercentage,
      recurringPercentage: data.recurringPercentage,
    };

    return new PaymentBreakDownModel(mappedData);
  }
}
